import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { jsonCopyObject, makeMapFromListOfObjectsAndKey, getSet, } from 'globals/helpers/helpers';
import { urlIsValid } from 'src/app/helpers/helpers';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SocialLink, socialLinkNamesList } from 'src/app/store/performers.era';
import { DialogWrapperComponent } from '../wrappers/dialog-wrapper.component';
import { FontCSS, JoiTemplate, getJoiTemplate } from 'globals/store/publish.data';
import { IconComponent } from '../icon/icon.component';
import { MutatingInputComponent } from '../joi-input/mutating-input.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'social-links-dialog',
    template: `
<dialog-wrapper
  [smallTitle]="true"
  [disabled]="hasInvalidEntry"
  [giveMeTwenty]="true"
  successLabel="SAVE"
  dialogTitle="Social links"
  [titleHeight]="40"
  [cancelLeft]="true"
  [style.--pagebackground]="template.pagebackground"
  [style.--font]="FontCSS[template.font]"
  [style.--header-font]="FontCSS[template.headerFont]"
  [style.--primary]="template.primary"
  [style.--primaryhover]="template.primaryhover"
  [style.--link]="template.link"
  [style.--contentbg]="template.contentbg"
  [style.--contentbgoutline]="template.contentbgoutline"
  [style.--innercontentbg]="template.innercontentbg"
  [style.--innercontentbgoutline]="template.innercontentbgoutline"
  (close)="cancel()"
  (cancel)="cancel()"
  (submit)="save()"
>
  <div class="grey-hint">Note: links must start with http or https</div>
  <div class="social-holder" *ngFor="let socialLinkName of socialLinkNames">
    <icon [icon]="'SOCIAL_' + socialLinkName" [class]="'social_' + socialLinkName.toLowerCase()"></icon>
    <mutating-input (textChange)="linkChanged($event)" [object]="socialLinks[socialLinkName]" prop="url" [placeholder]="(socialLinkName === 'Twitter' ? 'X' : socialLinkName)" ></mutating-input>
  </div>
</dialog-wrapper>
`,
    styleUrls: ['./socialLinks.dialog.scss'],
    standalone: true,
    imports: [DialogWrapperComponent, IconComponent, MutatingInputComponent, CommonModule],
})
export class SocialLinksDialogComponent implements OnInit {
  socialLinks: { [type: string]: SocialLink }
  socialLinkNames = socialLinkNamesList
  hasInvalidEntry = false
  template: JoiTemplate = getJoiTemplate()
  FontCSS = FontCSS
  @ViewChild(DialogWrapperComponent, { static: true }) dialogWrapper : DialogWrapperComponent;

  constructor(public dialogRef: MatDialogRef<SocialLinksDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SocialLinksData,
  ) { 
    if (data.template) this.template = data.template
  }

  ngOnInit() {
    const { social, x, y } = this.data
    this.socialLinks = social ? makeMapFromListOfObjectsAndKey(jsonCopyObject(social), 'type') : {}
    console.log({socialLinks: this.socialLinks, socialLinkNamesList});
    socialLinkNamesList.forEach(socialLinkName => {
      if (!this.socialLinks[socialLinkName]) {
        this.socialLinks[socialLinkName] = { type: socialLinkName, url: '' }
      }
    })
    this.dialogRef.updatePosition({ top: (Math.max(y - 350,0)) + 'px', left: x + 'px' });
    setTimeout(() => {
      this.dialogWrapper.fitChildren()
    }, 200);
  }

  linkChanged(link) {
    this.hasInvalidEntry = !Object.values(this.socialLinks).every(({ url }) => urlIsValid(url))
  }

  trackByLink(index, link: string) {
    return link
  }

  save() {
    this.data.social = [] // all of this is to keep them in order
    const socialLinks = Object.values(this.socialLinks).filter(socialLink => socialLink.url)
    const socialSet = getSet(socialLinks, 'type')
    const socialObject = makeMapFromListOfObjectsAndKey(socialLinks, 'type')
    socialLinkNamesList.forEach(type => {
      if (socialSet.has(type)) {
        this.data.social.push(socialObject[type])
      }
    })
    this.dialogRef.close()
  }

  cancel() {
    this.dialogRef.close()
  }
}

export interface SocialLinksData {
  social: SocialLink[]
  x: number
  y: number,
  template?: JoiTemplate
}
